const RESOURCE_NAME = '/drivers';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),

    saveDriverGroups(id, data, params) {
        return axios.post(`${RESOURCE_NAME}/${id}/update-groups`, data, {params});
    },

    getPhoto(id, params) {
        return axios.get(`${RESOURCE_NAME}/${id}/photo`, {params});
    },

    getSmsServices(params) {
        return axios.get(`${RESOURCE_NAME}/send-sms`, {params});
    },
    sendSms(data, params) {
        return axios.post(`${RESOURCE_NAME}/send-sms`, data, {params});
    },
    synchronizationPreview(data, params) {
        return axios.post(`${RESOURCE_NAME}/synchronization/preview`, data, {
            params,
            headers: {
                'content-type': 'multipart/form-data',
            },
        });
    },
    synchronizationSave(data, params) {
        return axios.post(`${RESOURCE_NAME}/synchronization/save`, data, {
            params,
            headers: {
                'content-type': 'multipart/form-data',
            },
        });
    },
});